import {edgeServer} from '../api_client/apiClient';
import AWS from 'aws-sdk';
import mqtt from 'mqtt';
import {getSignedUrlForMqttWebSocket} from '../util/SigV4Utils';
import {pushState, setClient, waitClient,} from '../actions/PushAction';
import {addMessage, addPushAlarm} from '../actions/CoachAction';

const getCredentials = (onCredential) => {
  edgeServer.get('/auth/identity/iot')
    .then(response => {
      /**
       * Use 'cognito-identity.amazonsaws.com' as a provider when even you are using custom auth provider if you are putting user identifier into the map.
       * @see <a href="https://forums.aws.amazon.com/thread.jspa?threadID=223868">aws forum thread 223868</a>
       */
      const cred = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: response.data.data.identity_pool_id,
        IdentityId: response.data.data.identity_id,
        Logins: {'cognito-identity.amazonaws.com': response.data.data.identity_token},
      }, {region: 'ap-northeast-1'});
      cred.get(callback => {
        if (callback) console.log(callback);
        else {
          onCredential(cred);
        }
      });
    })
    .catch(error => {
      console.log(error);
    });
};

const getMqttClient = (dispatch, getState, onClient) => {
  if (getState().push.client) onClient(getState().push.client);
  else if (getState().push.state !== 'not_initialized') {
    dispatch(waitClient(onClient));
  } else {
    dispatch(pushState('requested'));
    dispatch(waitClient(onClient));
    getCredentials(cred => {
      AWS.config.update({
        region: 'ap-northeast-1',
        credentials: cred,
      });
      const urlToConnect = getSignedUrlForMqttWebSocket(
          'a12xwb0rtivnfg.iot.ap-northeast-1.amazonaws.com',
          'ap-northeast-1',
          AWS.config.credentials,
      );
      const client = mqtt.connect(urlToConnect);
      dispatch(setClient(client));
      client.on('connect', () => {
        console.log("connect");
        dispatch(pushState('connect'));
      });
      client.on('message', (topic, message) => {
        dispatch(handleMessage(topic, message));
      });
      client.on('close', () => {
        dispatch(pushState('close'));
      });
      client.on('offline', () => {
        dispatch(pushState('offline'));
      });
    });
  }
};

export const subscribe = topic => (dispatch, getState) => {
  getMqttClient(dispatch, getState, client => {
    if (client.connected) {
      client.subscribe(topic);
    } else {
      client.on('connect', () => {
        client.subscribe(topic)
        console.log(`Subscribed topic ${topic}`);
      });
    }
  });
};
export const unsubscribe = topic => (dispatch, getState) => {
  getMqttClient(dispatch, getState, client => {
    if (client.connected) {
      client.unsubscribe(topic);
      console.log(`Unsubscribed topic ${topic}`);
    }
  });
};

const handleMessage = (topic, message) => (dispatch, getState) => {
  if(`${topic}`.startsWith('edge-coaching-message')) {
    let pushMessage = JSON.parse(message);
    switch (pushMessage.type){
      case 'INSERT':
        dispatch(addMessage(pushMessage.data));
        break;
      default:
        return;
      // case 'MODIFY':
      //   dispatch(setMessage(data.chatroom_id, data.id, data));
      //   break;
      // case 'REMOVE':
      //   dispatch(removeMessage(data.chatroom_id, data.id));
      //   break;
    }

  }else if(`${topic}`.startsWith('edge-coaching-chatroom')) {
    let pushMessage = JSON.parse(message);
    if(pushMessage.data.unread>0){
      dispatch(addPushAlarm(pushMessage.data));
    }
  }
};



// WEBPACK FOOTER //
// ./src/fetch/PushFetch.js